import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 */
export class AppointmentSlotSellerValueObject extends ValueObject {
  /**
   * @param {Object}  deps
   * @param {String}  deps.from
   * @param {String}  deps.to
   */

  getAppointment() {
    return {from: this._from, to: this._to}
  }
}
